import { useQuery } from '@tanstack/react-query'
import { api } from './client'

/** The company's own details (company.profile), printed at the top of every document */
export interface Company {
  /** The record's, from its own page's request (its activity); documents that print the company may leave it out */
  id?: string
  name: string
  nameEn?: string | null
  taxId?: string | null
  branch?: string | null
  address?: string | null
  phone?: string | null
  email?: string | null
  website?: string | null
  signerUserId?: string | null
  signerTitle?: string | null
  /** The authorized signer as documents print them, while they keep a signature */
  signer?: { userId: string; name: string; title: string | null; fileId: string } | null
}

export const companyQueryKey = ['company'] as const

/** One record for the whole system; readable by everyone signed in (document headers). */
export function useCompany() {
  return useQuery({
    queryKey: companyQueryKey,
    queryFn: () => api.get<{ item: Company | null }>('/company/profile').then((r) => r.item),
    staleTime: 3_600_000,
  })
}

export function saveCompany(values: Record<string, unknown>): Promise<Company> {
  return api.put<{ item: Company }>('/company/profile', values).then((r) => r.item)
}
